import { getUser } from '../auth/authService';

const CHAT_BASE = `${process.env.REACT_APP_CHAT_MICROSERVICE_URL ?? ''}`;

async function authHeaders() {
    const user = await getUser();
    if (!user?.access_token) throw new Error('Not authenticated');
    return {
        'Content-Type': 'application/json',
        Authorization: user?.access_token ? `Bearer ${user.access_token}` : '',
    };
}

async function parseError(res) {
    try {
        const body = await res.json();
        return body?.detail ?? `HTTP ${res.status}`;
    } catch {
        const text = await res.text().catch(() => '');
        if (!text || text.trimStart().startsWith('<')) return `HTTP ${res.status}`;
        return text.slice(0, 300);
    }
}

async function request(path, options = {}) {
    const headers = { ...(await authHeaders()), ...(options.headers || {}) };
    const res = await fetch(`${CHAT_BASE}${path}`, { ...options, headers });
    if (!res.ok) throw new Error(await parseError(res));
    return res.json();
}

export const getClients = async () => {
    const data = await request('/modularity/AllClients');
    return {
        clients: (Array.isArray(data) ? data : []).map((c) => ({
            clientId: c.NexusClient_Id,
            name: c.ClientName,
        })),
    };
};

export const getClientUsers = (clientId) =>
    request(`/modularity/clients/users?client_id=${encodeURIComponent(clientId)}`);
